export const ROUTES = {
  LOGIN: '/login',
  VERIFY: '/verify',
  LANDING: '/landing',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/resetPassword',
  ALL_CONTACT_CREW_DEPARTMENT: '/dept-contacts',
  SIGNUP: '/signup',
  DASHBOARD: '/',
  shiftDetail: '/shift_detail',
  shiftDetailCart: 'shift_detail_cart',
  PRODUCTION_DETAIL: '/production-detail',
  CREATE_SET: '/set',
  SET_DETAIL: '/set-detail',
  CREATE_DEPARTMENT: '/create-department',
  WELCOME: '/welcome',
  POLICIES: '/policies',
  PRIVACY_POLICY: '/privacy-policy',
  VENDOR_PRODUCTS: '/vendor-products',
  VENDOR_SERVICES: '/vendor-services',
  VENDOR_GROUPS: '/vendor-groups',
  ORDERS_SETTINGS: '/orders-settings',
  PROFILE: '/profile',
  TERMS: '/terms-conditions',
  TERMS_CONDITION: '/terms-&-conditions',
  ALL_EPISODE_SET_type: '/sets',
  FAQ: '/faq',
  FAQ_PAGE: '/faq-page',
  ASSOSIATED_LIST: '/assosiated-list',
  TOTAL_PRODUCTIONS: '/total-productions',
  SUPPORT: '/support',
  ALL_ORDERS_DEPT: '/all-orders',
  TOTAL_EPISODES: '/total_episodes',
  TOTAL_LOCATIONS: '/total_locations',
  TOTAL_SETS: '/total_sets',
  RELATED_SETS: '/related_sets',
  TOTAL_LOCATION_SETS: '/total_sets_location',
  TOTAL_PRODUCTION_EPISODE: '/total-production-episode',
  ACTIVE_LOCATION_SET: '/active-location-set',
  ALL_EPISODE_SET: '/view-all',
  ALL_DEPARTMENT: '/all-department',
  MANAGE_DEPARTMENT: '/manage-department',
  ALL_ORDERS: '/view-all-orders',
  ALL_DOCUMENTS: '/view-all-documents',
  GROUP_DETAIL: '/group-detail',
  ALL_CONTACT_CREW: '/view-all-contacts-crew',
  // underdevelopment:'/orders',
  BUSINESSINFO: '/business-info',
  VENDORS: '/vendors',
  VENDOR_PROFILE: '/vendor-profile',
  ORDERS: '/orders',
  STATIC_CONTENT: '/static-content',
  ADD_FAQ: '/add-faq',
  FINANCIALS: '/financials',
  NOTIFICATIONS: '/notifications',
  ALL_SERVICES: 'all-services',
  ADD_NOTIFICATIONS: '/add-notifications',
  BANNER: '/banners',
  ADD_BANNER: '/add-banner',
  ADD_VENDOR_BANNER: '/add-vendor-banner',
  CLIENTS: '/clients',
  USERS: '/users',
  USERS_PROFILE: '/user-profile',

  EDIT_FAQ: '/edit-faq',
  PRODUCT_Dashboard: '/product-dashboard',
  MY_PRODUCTION: '/my-productions',
  ADD_PRODUCTS: '/add-product',
  ADD_SERVICES: '/add-service',
  EDIT_USER_PROFILE: '/edit-user',
  ROLES: '/roles',
  CREATE_DETAILS: '/role-details',
  MANAGE_PRODUCTION: '/productions',
  CREATE_PRODUCTION: '/create-production',
  EPISODE_DETAIL: '/episode-detail',
  EPISODE: '/episode',
  MY_EPISODE: '/my-episode',
  MY_SET: '/my-set',
  CREATE_EPISODE: '/create-episode',

  LOCATION_DETAIL: '/location-detail',
  CREATE_LOCATION: '/location',
  DEPARTMENT_DETAIL: '/department-detail',
  // EDIT_PRODUCTION: '/edit-production',
  COMPANY_MANAGEMENT: '/company-management',
  CREATE_COMPANY: '/create-company',
  REQUESTS: '/requests',
  VIEW_REQUEST: '/view-request',
  ORDERS_DETAILS: '/order-details/:id',
  ORDERS_WORKSHEET: '/order-worksheet',
  ORDERS_PRODUCTS: '/order-products',
  ADD_PRODUCTS_ORDERS: '/add-products-order',
  ORDER_SERVICES: '/chats/orders',
  CREATE_ORDER: '/chats/create-order',
  CHATS: '/chats',
  COMMISSIONS: '/commissions',
  COMMISSIONS_EDIT: '/edit-commissions',
  PROFILE_SETUP: '/profile-setup',
  SELECT_DEPARTMENT: '/select-department',
  SELECT_POSITION: '/select-position',
  SELECT_PHOTO: '/profile-photo',
  ADD_CONTACT: '/add-contact',
  ADD_CONTACT_PRODUCTS: '/add-contact-products',
  GET_SUPPORT: '/contact-us',
  CONTACT_US: '/contact-us',
  RISK: '/risk',
  RISK_EVENT_DETAIL: '/event-detail',
  RISK_USER_DETAIL: '/user-detail',
  RISK_BOOK_SERVICE: '/book-service',
  RISK_SERVICE_DETAIL: '/service-detail',
  RISK_CART: '/cart',
  BOOKING_DETAILS: '/booking-details',
  EVENTS: '/events',
  PRODUCTION_DASHBOARD: '/production-dashboard',
  LOCATION_DASHBOARD: '/location-dashboard',
  SET_DASHBOARD: '/set-dashboard',
  EPISODE_DASHBOARD: '/episode-dashboard',
  // SPENDING_DASHBOARD: '/spendings',

  STORE: '/store',
  STOREPRODUCTS: '/store-products',
  STORESERVICES: '/store-services',
  STOREFAVOURITES: '/store-favorites',
  STOREVEDNDORS: '/store-vendors',
  STOREPACKAGES: '/store-packages',
  STORESEARCH: '/store-search',
  SEARCH: '/search',
  VENDORDETAILS: '/store-vendor-details',
  PRODUCTDETAILS: '/store-product-details',
  SERVICEDETAILS: '/store-service-details',
  PACKAGEDETAILS: '/store-package-details',
  CHANGE_DEPARTMENT: '/change-department',
  STORE_CATEGORIES: '/store-categories',
  VENDOR_SEARCH: '/store-vendor-search',

  ACTIVESETS: '/active-sets',
  ACTIVEORDERS: '/active-orders',
  ACTIVEDOCUMENTS: '/active-documents',
  REQUESTTOJOIN: '/request-to-join',
  CREWMEMBERS: '/crew-members',

  // ORDERS: '/orders'

  // MY_SET: '/my-set',
  MY_LOCATIONS: '/my-locations',

  EXPLORE: '/explore',
  STUDIO_DASHBOARD: '/studio-dashboard',
  VIEW_ACCESS: '/view-access',
  VIEW_ALL: '/view-all',
  VIEW_ALL_PRODUCTIONS: '/view-all-productions',
  VIEW_ALL_EPISODE_SET: '/view-all-episode-set',
  VIEW_ALL_SET: '/view-all-set',
  VIEW_ALL_SET_LOCATION: '/view-all-set-location',

  EPISODE_SET: '/episode-set',
  SCHEDULAR: '/schedular',
  LOCATION: '/locations',
  PRODUCTION: '/production',

  MY_DOCUMENT: '/my-document',
  UPLOAD_DOCUMENT: '/upload-document',

  SPENDINGS: '/spendings',
  PRODUCTION_SPENDINGS: '/production-spendings',
  DEPARTMENT_SPENDINGS: '/department-spendings',
  EPISODE_SPENDINGS: '/episode-spendings',
  SET_SPENDINGS: '/set-spendings',
  LOCATION_SPENDINGS: '/location-spendings',
  STUDIO_DEPARTMENT_SPENDINGS: '/studio-department-spendings',

  //studio
  CREATE_STUDIO: '/create-studio',
  STUDIO_DETAIL: '/studio-detail',
  VIEW_ALL_PROD: '/view-all-produtions',
  VIEW_ALL_ORDER: '/view-all-order',
  VIEW_ALL_DOC: '/view-all-documents',
  ADD_CONTACT_STUDIO: '/add-contact-studio',
  STUDIO_CONTACT_CREW: '/studio-contact-crew',
  MANAGE_STUDIO: '/manage-studio',
  ADD_CONTACT_ROLES_STUDIO: '/add-contact-roles-studio',

  //production
  ADD_CONTACT_ROLES_PRODUCTION: '/add-contact-roles-production',

  //episode
  ADD_CONTACT_ROLES_EPISODE: '/add-contact-roles-episode',

  //set
  ADD_CONTACT_ROLES_SET: '/add-contact-roles-set',

  //location
  ADD_CONTACT_ROLES_LOCATION: '/add-contact-roles-location',

  //department
  ADD_CONTACT_ROLES_DEPARTMENT: '/add-contact-roles-department',

  //studio department detail page
  STUDIO_DEPARTMENT_DETAIL: '/studio-department-detail',

  //episode department detail page
  EPISODE_DEPARTMENT_DETAIL: '/episode-department-detail',

  //set department detail page
  SET_DEPARTMENT_DETAIL: '/set-department-detail',

  //location department detail page
  LOCATION_DEPARTMENT_DETAIL: '/location-department-detail',

  //restricted permisssion route
  RESTRICTED_PERMISSION: '/restricted-permission',

  //Order
  START_ORDER: '/start-order',
  PREVIEW_SHIFT: '/preview-shift',
  ORDER_DEATIL: '/order-detail',
  ADD_MORE_ITEMS: '/add-more-items',
  MY_ORDER_ADD_MORE_ITEMS: '/my-order-add-more-items',
  ORDERS_LIST: '/orders-list',
  ORDER_DETAILS: '/order-details',
  RETURN_ORDER_DETAIL: '/returned-order-detail',
  ORDER_REQUEST: '/order-request',
  VENDOR_REQUEST: '/vendor-request',
  ADD_TO_ORDER: '/add-to-order',
  ORDER_CONTACT: '/order-contact',
  MY_ORDER_ADD_TO_ORDER: '/my-order-add-to-order',
  ORDER_PREVIEW_SHIFT: '/order-preview-shift',
  UPDATE_SHIFTS: '/update-shifts',
  ORDER_WORKSHEET: 'order-worksheet',

  FINANCE_ALL_ORDERS: '/finance-all-orders',

  //Invoice
  INVOICE_DETAIL: '/invoice-detail',

  FINANCE: '/finance',

  INVOICES: '/invoices',
  INVOICE_REQUESTS: '/invoice-requests',
  /** `from` query value so invoice detail keeps "Invoice Requests" highlighted in the sidebar. */
  INVOICE_DETAIL_FROM_REQUESTS: 'invoice-requests',
  PAYMENT_HISTORY: '/payment-history',
  WORKSHEET: '/invoice-worksheet',
  INVOICE_LISTING: '/invoice-listing',
  ORDER_INVOICE_DETAIL: '/order-invoice-detail',

  //Deeplink
  DEEPLINK: 'deeplink',

  //Return
  RETURN_REQUEST: '/return-request',
  PAYMENT_PAGE: '/payment-page',

  //Risk center
  RISK_SECURITY: '/risk',
  RISK_CENTER: '/risk-center',
  ADD_THREAT: '/add-threat',
  PRODUCTION_SECURITY_DASHBOARD: '/production-security-dashboard',
  SET_SECURITY_DASHBOARD: '/set-security-dashboard',
  EPIOSDE_SECURITY_DASHBOARD: '/episode-security-dashboard',
  LOCATION_SECURITY_DASHBOARD: '/location-security-dashboard',
  THREAT_DETAIL: '/threat-detail',
  ACTIVE_THREATS: '/active-threats',
  VIEW_ALL_STUDIO_PRODUCTIONS: '/studio-productions',
  VIEW_ALL_PRODUCTION_SETS: '/productions-sets',
  VIEW_ALL_EPISODE_SETS: '/episode-sets',
  VIEW_ALL_SET_LOCATIONS: '/set-locations',
  BLOCKLIST: '/block-list',
};

// Minute interval for the shared TimePicker (change here to update everywhere)
export const TIME_PICKER_MINUTES_STEP = 15;

export const standardErrorMsg = 'Something went wrong!';

export const ErrorMsg = (value: number | string) => {
  return {
    min: `Min. ${value} Characters allowed.`,
    max: `Max. ${value} Characters allowed`,
    required: `${value} is required.`,
    onlyLetter: `${value} should only contain letters`,
    email: `Please enter valid email address.`,
    string: ``,
    typeError: `Must be a Number`,
    positive: `Must be a positive Number`,
    integer: `Must be an Integer`,
    array: ``,
  };
};
export const MaxFileSizeLimit = 100 * 1024 * 1024;

export enum PRODUCT_TYPES {
  purchase = 'Purchase',
  rental = 'Rental',
  rentAndPurchase = 'Rental/Purchase',
}

export enum BACKEND_P_TYPES {
  PURCHASE = 'PURCHASE',
  RENTAL = 'RENTAL',
  RENTAL_AND_PURCHASE = 'RENTAL_AND_PURCHASE',
}

export const allowedImageMimeType = [
  'image/jpeg', //.jpg | .jpeg
  'image/png', // .png
  'image/gif', // .gif
  'image/svg+xml', // .svg,
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.svg',
  '.heic',
];
export const allowedAudioMimeType = [
  'audio/aac', // .aac
  'audio/mp4', // .m4a
  'audio/x-wav', // .wav .wave
  'audio/x-aiff', //.aff .aif .aiff
  'application/ogg', // .ogg
  'audio/mpeg', // .ogg,
  '.ogg',
  '.aff',
  '.aif',
  '.aiff',
  '.wav',
  '.wave',
  '.m4a',
  '.aac',
];
export const allowedVideoMimeType = [
  'video/x-ms-wmv', // .wmv
  'video/avi', // .avi
  'video/quicktime', // .mov
  'video/mp4', // .mp4
  'video/x-flv', // .flv
  '.flv',
  '.mp4',
  '.mov',
  '.avi',
  '.wmv',
  '.heic',
];
export const allowedDocsMimeType = [
  'application/pdf', //.pdf
  'application/vnd.ms-excel', // MS Excel File (.xlsx,. xls)
  '.pdf',
  '.xls',
];
export const allMediaMimeType = [
  ...allowedDocsMimeType,
  ...allowedAudioMimeType,
  ...allowedImageMimeType,
  ...allowedVideoMimeType,
];
export const CHAT_ACTIVE = 'ACTIVE';
export const CHAT_DELETED = 'DELETED';
export const CHAT_UPLOADING = 'UPLOADING';
export const CHAT_FAILED = 'FAILED';
export const CHAT_ORDER_COMPLETED = 'ORDER_COMPLETED';
export const MEDIA_TYPES = ['IMAGE', 'MEDIA', 'DOCS', 'VIDEO'];
export const USER_ADMIN_CHAT = 'user_user_chat';
export const VENDOR_ADMIN_CHAT = 'user_vendor_chat';
export const DEFAULT_URL = [
  'https://app-development.s3.amazonaws.com/ReelProject/1701757389017user%20%281%29.png',
  'https://app-development.s3.amazonaws.com/ReelProject/1709702563475_User_Placeholder.png',
];
export const ADMIN_FIRSTNAME = 'Reeltrack Support';
export const ADMIN_PROFILE_PIC =
  'https://pre-images.reeltrak.com/ReelProject/imgpsh_fullsize_anim.png';
export const DEFAULT_ADMIN_ID = '66705d5d0b99f01dd013ab7c';
// 100 MB
export const MAX_FILE_SIZE_CHAT = 100 * 1024 * 1024;
// 10 files
export const MAX_FILES = 10;
export const USER_TYPE_MAP = {
  [VENDOR_ADMIN_CHAT]: 'VENDOR',
  [USER_ADMIN_CHAT]: 'USER',
};

export const mapStyles = [
  {
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5', // Light background color for landmasses
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#BDC3C7',
      },
      {
        weight: 1,
      },
      {
        dashArray: [2, 2], // Dotted borders
      },
    ],
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off', // Disable icon labels
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#616161', // Darker text color
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#ffffff', // White stroke around labels
      },
    ],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#bdbdbd', // Light color for land parcel labels
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off', // Hide points of interest labels
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff', // White color for road fill
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#e0e0e0', // Light color for road strokes
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off', // Disable road icon labels
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#e5e5e5', // Light grey for highways
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#e0e0e0', // Light grey for highway stroke
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off', // Disable highway icon labels
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e5e5e5', // Light color for transit
      },
    ],
  },
  {
    featureType: 'transit.station',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#757575', // Grey color for transit station text
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#C9E1FF', // Light blue color for water
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e', // Light grey color for water text
      },
    ],
  },
];

export const SHIFT_COVERAGE: any = {
  Day: 'DAY',
  Night: 'NIGHT',
  '24 Hrs': '24H',
  'Swing Shift': 'SWING_SHIFT',
};
export const getMinimumRentPricing = (rentPricing = []) =>
  rentPricing.length
    ? rentPricing.reduce((prev, curr) =>
        prev.rentPrice < curr.rentPrice ? prev : curr,
      )
    : null;

export const getRateModelFromPricing = pricingItem =>
  pricingItem?.priceMode === 'PER_HOUR'
    ? 'HOURLY'
    : pricingItem?.priceMode === 'PER_DAY'
    ? 'DAILY'
    : pricingItem?.priceMode === 'PER_WEEK'
    ? 'WEEKLY'
    : pricingItem?.priceMode === 'PER_MONTH'
    ? 'MONTHLY'
    : '';

export const getEffectiveDiscount = item => {
  if (item.type === 'PURCHASE') return item.discount;
  if (item.type === 'RENTAL') return item.rentDiscount;
  return item.discount > item.rentDiscount ? item.rentDiscount : item.discount;
};

export const getEffectiveDiscountType = item => {
  if (item.type === 'PURCHASE') return item.discountType;
  if (item.type === 'RENTAL') return item.rentDiscountType;
  return item.discount > item.rentDiscount
    ? item.rentDiscountType
    : item.discountType;
};

export const checkRateModelType = (
  rateModel: string,
  minDuration?: string | any,
) => {
  return rateModel === 'HOURLY'
    ? 'hr'
    : rateModel === 'WEEKLY'
    ? 'week'
    : rateModel === 'DAILY'
    ? minDuration === 1
      ? 'day'
      : 'days'
    : 'months';
};

export enum SHOPPING_MODE {
  BUY = 'BUY',
  RENT = 'RENT',
  SERVICE = 'SERVICE',
}

export enum PRODUCT_TYPESS {
  RENTAL = 'RENTAL',
  VENDOR = 'VENDOR',
  SERVICE = 'SERVICE',
  PACKAGE = 'PACKAGE',
  VENDOR_PRODUCT = 'VENDOR_PRODUCT',
  VENDOR_SERVICES = 'VENDOR_SERVICE',
  PRODUCT = 'PRODUCT',
  PURCHASE = 'PURCHASE',
  PURCHASE_AND_RENTAL = 'RENTAL_AND_PURCHASE',
}

// Transaction status
export enum TRANSECTION_STATUS {
  PAID = 'PAID',
  FAILED = 'FAILED',
  UNPAID = 'UNPAID',
}

// My order tracking status
export const ORDER_PLACED_STATUS = {
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETED',
  PLACED: 'PLACED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  DELIVERED: 'DELIVERED',
  INPROGRESS: 'INPROGRESS',
  RETURNED: 'RETURNED',
  SHIPPED: 'SHIPPED',
  INTRANSIT: 'INTRANSIT',
  STARTED: 'STARTED',
  ENDED: 'ENDED',
  CANCEL_REQUESTED: 'CANCEL_REQUESTED',
};

// Tracking steps configuration
export const TRACKING_STEPS = {
  RENTAL: [
    {
      title: 'Order Placed',
      status: ORDER_PLACED_STATUS.PLACED,
      message: 'Your order has been placed',
      state: false,
    },
    {
      title: 'Shipped',
      status: ORDER_PLACED_STATUS.SHIPPED,
      message: 'Your order has been shipped by Vendor',
      state: false,
    },
    {
      title: 'In Transit',
      status: ORDER_PLACED_STATUS.INTRANSIT,
      message: 'The order is currently en route',
      state: false,
    },
    {
      title: 'Delivered',
      status: ORDER_PLACED_STATUS.DELIVERED,
      message: 'Your order has been successfully Delivered',
      state: false,
    },
    {
      title: 'Service Started',
      status: ORDER_PLACED_STATUS.STARTED,
      message: 'Service has been Started',
      state: false,
    },
    {
      title: 'Service Ended',
      status: ORDER_PLACED_STATUS.ENDED,
      message: 'Service has been ended',
      state: false,
    },
  ],
  SERVICE: [
    {
      title: 'Order Placed',
      status: ORDER_PLACED_STATUS.PLACED,
      message: 'Your order has been placed',
      state: false,
    },
    {
      title: 'Services Started',
      status: ORDER_PLACED_STATUS.STARTED,
      message: 'Service has been started',
      state: false,
    },
    {
      title: 'Service Ended',
      status: ORDER_PLACED_STATUS.ENDED,
      message: 'Service has been ended',
      state: false,
    },
    {
      title: 'Service Completed',
      status: ORDER_PLACED_STATUS.COMPLETED,
      message: 'Service has been successfully Completed',
      state: false,
    },
  ],
  PURCHASE: [
    {
      title: 'Order Placed',
      status: ORDER_PLACED_STATUS.PLACED,
      message: 'Your order has been placed',
      state: false,
    },
    {
      title: 'Shipped',
      status: ORDER_PLACED_STATUS.SHIPPED,
      message: 'Your order has been shipped by Vendor',
      state: false,
    },
    {
      title: 'In Transit',
      status: ORDER_PLACED_STATUS.INTRANSIT,
      message: 'The order is currently en route',
      state: false,
    },
    {
      title: 'Delivered',
      status: ORDER_PLACED_STATUS.DELIVERED,
      message: 'Your order has been successfully Delivered',
      state: false,
    },
  ],
};

export const formatDateTime = (timestamp: string) => {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

export const formatDate = (timestamp: string) => {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const formatTime = (timestamp: string) => {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  return date.toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });
};

export const STORE_ACCESS_DENIED_MESSAGE = 'You do not have the store access';

export const TOTAL_ESTIMATE_COST_TOOLTIP =
  'Sum of all orders placed. This value updates as new services are added. Cancelled products, services, or shifts may be included in this value.';
// 'All Orders is based on products and services (including overtime and additional fees) from orders. This value updates as new services are added and assigned.';
// 'The total estimate reflects the values from the invoice, including the cost of shifts, OT/DT, and additional charges such as Rush Fee, Per Diem, and Mileage.';

export const TOTAL_ACTUAL_COST_TOOLTIP =
  'Reflects the verified cost of completed shifts, overtime, and additional charges. This value includes invoiced credits/additions.';
// 'Actuals are finalized once shift times are confirmed. The Total Actual reflects the verified cost of completed shifts, overtime, and additional charges. This value does not include invoiced credits/additions.';
// 'The total actual cost includes the actual cost of shift, OT/DT and additional charges such as Rush Fee, Per Diem and Mileage.';

export const CURRENT_ORDER_ESTIMATE_TOOLTIP =
  'Sum of all orders placed.  This value updates as new orders are added.';

export const VARIANCE_FROM_ESTIMATE_TOOLTIP =
  'The difference between all orders and the total billable cost.';
// 'The difference between the Adjusted Order Estimate and the Total Actual Billable Cost.';

export const WORKSHEET_ACTUAL_COST_TOOLTIP =
  'Actuals are finalized once shift times are confirmed. The Total Actual reflects the verified cost of completed shifts, overtime, and additional charges.';

export const WORKSHEET_VARIANCE_TOOLTIP =
  'The difference between the all orders and the Actual Cost. Not including invoiced credits/additions.';

export const WORKSHEET_ADJUSTEDORDERS_TOOLTIP =
  'Current updated order value. This value updates as additions, cancellations or other edits occur.';

export const SPENDING_BY_ENTITY_TOOLTIP =
  'Submitted Orders represents the 100% baseline. Adjusted Order Estimate and Actual Cost are shown as contextual percentages against the Submitted Orders value.';
export const SPENDING_ADDITIONAL_TOOLTIP =
  'Additional Charges are excluded from this graph and pie chart and areincluded only in the Total Billable Cost summary.';
